export const ASSOCIATION_MODES = {
  CATEGORY: 'CATEGORY',
  NARRATIVE: 'NARRATIVE',
  FILTER: 'FILTER'
}
